// extracted by mini-css-extract-plugin
export default {"container":"SafeAreaInsetPage_container__rDe+E","insetHeader":"SafeAreaInsetPage_insetHeader__PAhFu","insetFooter":"SafeAreaInsetPage_insetFooter__J-IbH"};